import React, { useCallback, useEffect, useState } from "react";
import Hoc from "../../../components/HOC";
import {
  requestDownloadInvoiceAction,
  requestGenerateInvoice,
  requestTimesheetAppAction,
  requestTimesheetListAction,
  responseTimesheetAppAction,
  setResetStateTimesheetApp,
  setResetTimesheetsAction,
  setResetGenerateInvoice,
} from "../../../Redux/TimeSheetState/TimeSheetActionCreator";
import { useDispatch, useSelector } from "react-redux";
import CustomDataTable from "../../../components/CustomDataTable";
import { toast } from "react-toastify";
import CustomToolTip from "../../../components/ToolTip";
import moment from "moment";
import { FcApproval } from "react-icons/fc";
import { MdDownload, MdOutlinePaid } from "react-icons/md";
import Loader from "../../../components/Loader";
import {
  requestInvoiceList,
  requestInvoicePaymentDate,
  setResetInvoicePaymentDate,
} from "../../../Redux/InvoiceState/InvoiceActionCreator";
import MuiDatePicker from "../../../components/MuiDatePicker";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from "react-icons/md";

function PendingInvoice() {
  const [selectedRowForPaid, setSelectedRowForPaid] = useState(null);
  const timesheetAppState = useSelector((state) => state.TimesheetAppReducer);
  const [isPaidDateModalOpen, setIsPaidDateModalOpen] = useState(false);
  const [paymentDate, setPaymentDate] = useState("");
  const invoicesList = useSelector((state) => state.InvoiceListReducer);
  const [search, setSearch] = useState(timesheetAppState?.search || "");
  const invoicePaymentDateReducer = useSelector(
    (state) => state.InvoicePaymentDateReducer
  );
  const generateInvoiceReducer = useSelector((state) => state.GenerateInvoiceReducer);
  const [sortBy, setSortBy] = useState(null); // null (ascending by default), 'desc' (descending)
  // Sync local search state with Redux state
  useEffect(() => {
    if (timesheetAppState?.search !== undefined && timesheetAppState.search !== search) {
      setSearch(timesheetAppState.search);
    }
  }, [timesheetAppState?.search]);

  const conditionalRowStyles = [
    {
      when: (row) => row.paymentDate && row.paymentDate !== row.invoiceDate,
      style: {
        backgroundColor: "#E0FFE0",
        color: "black",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#E0FFE0",
          color: "#black",
        },
      },
    },
  ];
  const handleEndDateSort = () => {
    const newSortBy = sortBy === 'asce' ? null : 'asce';
    setSortBy(newSortBy);
   
  };
  const columns = [
    {
      name: "Employee Name",
      selector: (row) => row.consultantName,
      
    },
    {
      name: "Client Name",
      selector: (row) => row.clientName,
      
    },
    {
      name: "Client Email",
      selector: (row) => row.clientEmail,
      sortable: true,
      hide: "sm",
      cell: (row) => (
        <span className="text-md font-medium truncate">
          {row.clientEmail}
        </span>
      ),
       minWidth: "200px"
    },
    {
      name: "Invoice Id",
      selector: (row) => row.invoiceId,
      sortable: true,
    },
    // {
    //   name: "Project Name",
    //   selector: (row) => row.projectName,
    //   sortable: true,
    // },
    // {
    //   name: "Client Name",
    //   selector: (row) => row.clientName,
    //   sortable: true,
    // },
    {
      name: "Invoice Period",
      selector: (row) => {
        const dates = row.invoicePeriod?.match(/\d{4}\/\d{2}\/\d{2}/g);
        return dates?.length === 2
          ? `From ${moment(dates[0], "YYYY/MM/DD").format("MM-DD-YYYY")} To ${moment(dates[1], "YYYY/MM/DD").format("MM-DD-YYYY")}`
          : row.invoicePeriod;
      },
     
    },
    {
      name: (
        <div className="flex items-center gap-2 cursor-pointer" onClick={handleEndDateSort}>
          <span>Invoice Date</span>
          {sortBy === 'desc' ? (
            <MdKeyboardArrowUp className="w-4 h-4 text-black-600" />
          ) : (
            <MdKeyboardArrowDown className="w-4 h-4 text-gray-400" />
          )}
        </div>
      ),
      selector: (row) => moment(row.invoiceDate).format("MM-DD-YYYY"),
      
    },
    // {
    //   name: "Total Hours",
    //   selector: (row) => row.hours,
    //   sortable: true,
    //   hide: "sm",
    // },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-4">
          <button
            onClick={() => handlePaidDate(row)}
            className="text-primary"
            disabled={row.paymentDate !== null}
            style={{
              color: row.paymentDate !== null ? "#D1D5DB" : "", // Manually setting the color to gray when disabled
            }}
          >
            <MdOutlinePaid size={24} data-tip data-for="Paid" />
            <CustomToolTip id="Paid" title="Paid Date" />
          </button>
        </div>
      ),
    },
  ];
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ratePerHour, setRatePerHour] = useState("");

  const handlePaidDate = (row) => {
    setIsPaidDateModalOpen(true);
    setSelectedRowForPaid(row);
  };

  const handleCheckboxChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);
  // const rowDisabledCriteria = (row) =>
  //   row.status !== "APP" || row.invoiceGenerated !== null;
  const handlePageChange = (page) => {
    dispatch(
      requestTimesheetAppAction({
        page: page,
        size: timesheetAppState.size,
        search: search,
        sortby: sortBy,
      })
    );
  };
  const handleRowsChange = (size) => {
    dispatch(requestTimesheetAppAction({ page: 0, size: size, search: search, sortby: sortBy }));
    // setSearch("");
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(setResetStateTimesheetApp());
      dispatch(
        requestTimesheetAppAction({
          page: 0,
          size: timesheetAppState?.size,
          search: search,
          sortby: sortBy,
        })
      );
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [search, timesheetAppState?.size]);



  
  // Separate useEffect for sort changes to maintain current page
  useEffect(() => {
    dispatch(setResetStateTimesheetApp());
    dispatch(
      requestTimesheetAppAction({
        page: timesheetAppState?.page || 0,
        size: timesheetAppState?.size,
        search: search,
        sortby: sortBy,
      })
    );
  }, [sortBy]);

  const handleConfirm = () => {
    if (!ratePerHour || selectedRows.length === 0) {
      toast.error("Please enter a valid rate and select timesheets.");
      return;
    }
    const payload = {
      timesheetIds: selectedRows.map((row) => row.id),
      ratePerHour: parseFloat(ratePerHour),
    };

    dispatch(requestGenerateInvoice(payload));
    setIsModalOpen(false);
  };
  const handleDownload = (row) => {
    dispatch(
      requestDownloadInvoiceAction({
        id: row.userId,
        invoiceId: row.invoiceGenerated,
      })
    );
    //  toast.success("Downloading Invoice!")
  };
  const handlePaymentDate = () => {
    dispatch(
      requestInvoicePaymentDate(
        selectedRowForPaid.invoiceId,
        selectedRowForPaid.userId,
        paymentDate
      )
    );
  };

  useEffect(() => {
    if (timesheetAppState?.error && !timesheetAppState?.loading) {
      // toast.error("No UsersList found / something went wrong")
      dispatch(setResetStateTimesheetApp());
    }
  }, [timesheetAppState]);

  useEffect(() => {
    return () => {
     dispatch(setResetStateTimesheetApp());
    }
   }, []);

  useEffect(() => {
    
    dispatch(requestTimesheetAppAction({ page: 0, size: timesheetAppState?.size || 10, search: search }));
    dispatch(setResetStateTimesheetApp());
  }, []);

  useEffect(() => {
    if (
      invoicePaymentDateReducer?.response &&
      !invoicePaymentDateReducer?.loading
    ) {
      dispatch(requestTimesheetAppAction({ page: 0, size: timesheetAppState?.size || 10, search: search }));
      dispatch(setResetInvoicePaymentDate());
      toast.success("Invoice Payment Date is Updated");
      setIsPaidDateModalOpen(false);
      setPaymentDate("");
    }
    if (
      invoicePaymentDateReducer?.error &&
      !invoicePaymentDateReducer?.loading
    ) {
      dispatch(setResetInvoicePaymentDate());
    }
  }, [invoicePaymentDateReducer]);

  useEffect(() => {
    if (
      generateInvoiceReducer?.response &&
      !generateInvoiceReducer?.loading
    ) {
      dispatch(requestTimesheetAppAction({ page: 0, size: timesheetAppState?.size || 10, search: search }));
      dispatch(setResetGenerateInvoice());
      toast.success("Invoice successfully generated!");
    }
    if (
      generateInvoiceReducer?.error &&
      !generateInvoiceReducer?.loading
    ) {
      dispatch(setResetGenerateInvoice());
    }
  }, [generateInvoiceReducer]);

  return (
    <div className="p-6 w-full h-[90vh]">
      <Loader isLoading={timesheetAppState.loading} />

      {isPaidDateModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center  z-50">
          <div className="bg-white p-6 rounded shadow-md w-[500px]">
            <h2 className="text-lg font-semibold mb-2">Enter Payment Date</h2>
            <MuiDatePicker
              label="Payment Date"
              value={paymentDate ? moment(paymentDate) : null}
              onChange={(date) => {
                setPaymentDate(moment(date).format("YYYY-MM-DD"));
              }}
              disabled={false}
              className="w-full h-10"
              minDate={moment(selectedRowForPaid.invoiceDate)} // Min date is invoiceDate, fallback to today if invoiceDate is not set
              maxDate={moment()} // Max date is today
            />
            <div className="flex justify-end mt-4">
              <button
                onClick={() => {
                  setIsPaidDateModalOpen(false);
                  setPaymentDate("");
                }}
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handlePaymentDate}
                className="bg-primary text-white px-4 py-2 rounded"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <CustomDataTable
        columns={columns}
        data={timesheetAppState?.response?.content || []}
        enableSearch={true}
        search={search}
        setSearch={setSearch}
        serverPagenation
        conditionalRowStyles={conditionalRowStyles}
        // selectableRows={true}
        paginationTotalRows={timesheetAppState?.response?.totalElements}
        handleChangePage={handlePageChange}
        handleRowsChange={handleRowsChange}
        fixedHeaderScrollHeight={"59vh"}
      />
    </div>
  );
}

export default Hoc(PendingInvoice);
